import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TooltipComponent } from '../../../tooltip/tooltip.component';

@Component({
  selector: 'app-lib-ff-template',
  styleUrls: ['./template.component.scss'],
  templateUrl: './template.component.html',
  imports: [TooltipComponent],
})
export class FormlyTemplateComponent extends FieldType {}
